import { __awaiter, __generator } from "tslib";
import { promptViewKey } from '.';
import { createFormInputDriver } from '../form-input/driver';
// tslint:disable-next-line:max-line-length
export var createBasePromptViewDriver = function (valueCompDriverCreator) { return function (wrapper) {
    var base = wrapper.$("." + promptViewKey);
    var valueCompDriver = valueCompDriverCreator(base);
    return {
        title: base.$('.title').text,
        enterValue: function (val) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, valueCompDriver.set(val)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, base.$('.enter').click()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        value: valueCompDriver.value,
        confirmText: function () { return base.$('.enter').text(); },
        cancelText: function () { return base.$('.cancel').text(); },
        // placeholder: () => {
        // 	if (valueCompDriver.placeholder) {
        // 		return valueCompDriver.placeholder();
        // 	} else {
        // 		return Promise.resolve('n/a');
        // 	}
        // },
        valid: function () {
            var valid = valueCompDriver.valid;
            return valid ? valid() : Promise.resolve(true);
        },
        base: base
    };
}; };
export var createPromptViewDriver = createBasePromptViewDriver(createFormInputDriver);
//# sourceMappingURL=driver.js.map